import { makeRequest } from '../client'

export const getTablesByRestaurant = async (restaurantId) =>
  makeRequest('table', 'getTablesByRestaurant', { restaurantId });

export const getTableById = async (id) =>
  makeRequest('table', 'getTableById', { id });

export const getTableByQrCode = async (qrCodeId) =>
  makeRequest('table', 'getTableByQrCode', { qrCodeId });

export const getPublicTableByNumber = async (restaurantId, tableNumber) =>
  makeRequest('table', 'getPublicTableByNumber', { restaurantId, tableNumber });
